/**
 * Adzuki
 * date_time_picker.js
 */

(function DateTimePicker($, Adzuki)
{
	"use strict";

	/**
	 * inits a date/time/datetime picker on el
	 * @param  {jQuery|string} el
	 * @param  {string} input_format  format of date/time displayed in the input
	 * @param  {string} output_format format of date/time submitted by form
	 */
	// http://momentjs.com/docs/#/parsing/string-format/
	var dateTimePicker = function DateTimePicker(el, input_format, output_format)
	{
		var $self,
		    opts = {},
		    display_format,
		    io_format,
		    is_date_only,
		    $hidden_input,
		    $linked_to,
		    $clear_btn,
		    self_dtp,
		    linked_dtp,
		    _link_detection;

		if (el instanceof jQuery) {
			$self = el;
		} else {
			$self = $(el);
		}

		if ($self.data('DateTimePicker')) {
			return;
		}

		if ($self.hasClass('no-adzuki-auto-init')) {
			return;
		}

		// init mobile datetimepicker shims
		if (Adzuki.is_mobile) {
			// we want the output format on mobile (native pickers)
			// beacuse it will be what the browser/server expects
			initMobileDTP($self, output_format);
			return;
		}

		// sets the initial expected i/o formats for dates and times
		display_format = $self.data('display-format') || input_format || 'MM/DD/YYYY';
		io_format      = $self.data('io-format') || output_format || 'YYYY-MM-DD';
		is_date_only   = !(/[Hhmsk]/).test(display_format + io_format);

		// x to clear input button
		$clear_btn = $self.siblings('.clear-datepicker');

		// change input's type, to avoid conflicting native/library UI
		$self.attr('type', 'text');

		// in order to support arbitrary io/display formats, the browser can't
		// be allowed to render a value for what is initially a date/time
		// html5 element, because it will throw a warning and wipe the value.
		// DefaultForm sets the value to data-value, and we swap attributes here
		if ($self.data('value') && $self.data('value') !== '0000-00-00') {
			$self.val($self.data('value'));
			$clear_btn.removeClass('hidden d-none');
		}

		// to be able to address it via css/js if needed
		$self.addClass('adzuki-datetimepicker');

		// append hidden input AFTER display input, preserve bootstrap styling
		$hidden_input = $('<input type="hidden">')
		    .attr('id', $self.attr('id') + '_hidden')
		    .attr('name', $self.attr('name'))
		    .val($self.data('value'))
		    .insertAfter($self);

		// remove input name, so it's ignored by form post
		$self.removeAttr('name');

		// removes the readonly attribute, if desired.
		// you shouldn't desire this.
		if ($self.data('enable-manual-edit')) {
			$self.removeAttr('readonly');
		}

		// set datetimepicker options
		opts.format         = display_format; // input display format
		opts.extraFormats   = [display_format, io_format]; // formats to parse
		opts.useCurrent     = false;
		opts.ignoreReadonly = true;
		opts.calendarWeeks  = true;
		opts.icons          = {
			time    : Adzuki.FaIcon.getIconStyle('clock', 'solid'),
			date    : Adzuki.FaIcon.getIconStyle('calendar', 'solid'),
			up      : Adzuki.FaIcon.getIconStyle('chevron_up', 'solid'),
			down    : Adzuki.FaIcon.getIconStyle('chevron_down', 'solid'),
			previous: Adzuki.FaIcon.getIconStyle('chevron_left', 'solid'),
			next    : Adzuki.FaIcon.getIconStyle('chevron_right', 'solid'),
			today   : Adzuki.FaIcon.getIconStyle('dot_circle', 'solid'),
			clear   : Adzuki.FaIcon.getIconStyle('trash', 'solid'),
			close   : Adzuki.FaIcon.getIconStyle('close', 'solid'),
		};

		// min/max attributes for date pickers are date-only, so they parse to
		// midnight. the picker builds the clicked date from the current time of
		// day when the input starts empty, which would fall outside a midnight
		// boundary and get rejected, wiping the input.
		if ($self.attr('max')) {
			opts.maxDate = moment($self.attr('max'));

			if (is_date_only) {
				opts.maxDate.endOf('day');
			}
		}

		if ($self.attr('min')) {
			opts.minDate = moment($self.attr('min'));

			if (is_date_only) {
				opts.minDate.startOf('day');
			}
		}

		if ($self.attr('stepping')) {
			opts.stepping = $self.attr('stepping');
		}

		if ($self.data('view-mode')) {
			opts.viewMode = $self.data('view-mode');
		}

		if ($self.data('view-date')) {
			opts.viewDate = moment($self.data('view-date'));
		}

		// when i die bury me inside a louis store
		if ($self.data('mode') === 'birthday') {
			opts.minDate  = moment('1900-01-01');
			opts.maxDate  = moment().endOf('day');
			opts.viewDate = moment('1900-01-01');
			opts.viewMode = 'decades';
		} else if ($self.data('mode') === 'credit-card') {
			opts.minDate  = moment().startOf('day');
			opts.viewMode = 'years';
			opts.format   = 'MM/YYYY';
		}

		// SET-141: INSIDE THE MY SETTINGS MODAL THE PICKER ALWAYS DROPS DOWN.
		//
		// The panel body scrolls (overflow: auto), so a picker that opens UPWARD is clipped by it -
		// the month header disappears behind the tab strip. The library's 'auto' choice is made
		// against the WINDOW, which is the wrong box: inside a scrolling panel there is always room
		// below, because the panel scrolls to make some.
		//
		// WHY NOT widgetParent. Re-parenting the widget out to the overlay is the fix the SET-16
		// comment in _my_settings.scss points at, and it does not work here: the library positions
		// from position() relative to the input's offsetParent, and Bootstrap's .input-group is
		// `position: relative` - so it IS that parent. Move the widget and those coordinates place it
		// somewhere else entirely.
		//
		// SCOPED TO THE OVERLAY so every other screen in the app keeps the library's own choice.
		if ($self.closest('.my-settings-overlay').length > 0) {
			opts.widgetPositioning = {
				horizontal: 'auto',
				vertical  : 'bottom',
			};
		}

		// init datetimepicker
		if ($self.data('use-tempus')) {
			// using the non-bootstrap version of the datetimepicker
			self_dtp = _initTempusDateTimePicker($self, opts);
			$self.data('DateTimePicker', self_dtp);
		} else {
			$self.datetimepicker(opts);
			self_dtp = $self.data('DateTimePicker');
		}

		// set up linked pickers
		if ($self.data('linked-to')) {
			$linked_to = $($self.data('linked-to'));

			// update linked pickers on change
			$linked_to.on('dp.change', function _updateLinkedPicker(e) {
				self_dtp.maxDate(_toDayBoundary(e.date, 'endOf', is_date_only));
			});

			// the linked datetimepicker probably hasn't fully initialized
			// by this point, so detect when it is to save the dtp reference.
			// this happens very quickly; in my tests, this only ever runs once.
			_link_detection = setInterval(function _detectLinkedPicker() {
				linked_dtp = $linked_to.data('DateTimePicker');

				// set initial boundaries for linked pickers
				if (linked_dtp !== undefined) {
					clearInterval(_link_detection);

					if (self_dtp.date() !== null) {
						linked_dtp.minDate(_toDayBoundary(self_dtp.date(), 'startOf', is_date_only));
					}

					if (linked_dtp.date() !== null) {
						self_dtp.maxDate(_toDayBoundary(linked_dtp.date(), 'endOf', is_date_only));
					}
				}
			}, 100);
		}

		// update hidden input with the proper date
		$self.on('dp.change', function updateHiddenField(e)
		{
			var date = null;

			if (e.date) {
				date = moment(e.date._d).format(io_format);

				// update linked picker
				if ($linked_to && linked_dtp) {
					linked_dtp.minDate(_toDayBoundary(e.date, 'startOf', is_date_only));
				}

				$clear_btn.removeClass('hidden d-none');
			} else {
				$clear_btn.addClass('hidden d-none');
			}

			// SET-16: TELL THE PAGE THE POSTED FIELD CHANGED. The picker removes the name from
			// the visible input and posts through this hidden one, and setting .val() dispatches
			// nothing - so anything watching the form's fields never learns the value moved. The
			// My Settings dirty tracker listens for change/input on the fields that post, which
			// is this one, so without the trigger a picked or cleared time could not be saved.
			$hidden_input.val(date).trigger('change');
		});

		// show picker when clicking on the calendar icon.
		// normally you'd init the datepicker on the .input-group parent, but
		// it was causing edge cases where it'd submit the wrong date format.
		$self.siblings('.input-group-addon').on('click', function showPicker() {
			self_dtp.show();
		});

		// clear input button
		$clear_btn.on('click', function clearDTP(event)
		{
			if ($self.is(':disabled')) {
				Adzuki.StatusMessage('info', 'This input is disabled and cannot be changed right now.', 'Info');
				return;
			}

			Adzuki.CustomConfirm({
				body   : 'Are you sure you wish to clear this field?',
				confirm: function confirm() {
					self_dtp.clear();
					// same reason as the change handler above - clearing announces itself too
					$hidden_input.val('').trigger('change');
					$clear_btn.addClass('hidden d-none');
				}
			});
		});
	};

	// mobile datetimepickers use their respective native implementations.
	// this creates api and event shims so code works as expected in mobile.
	function initMobileDTP($el, input_format)
	{
		var _input_format = input_format || 'YYYY-MM-DD',
		    _dt_modifier  = 'second',
		    _dtval;

		// api shim
		$el.data('DateTimePicker', {
			date: function date(argv, init) {
				// date() - no args, return the current value as a moment
				if (typeof argv === 'undefined') {
					return moment($el.val());
				}
				// date(null|false) - null/false arg, clear input
				else if (argv === null || argv === false) {
					this.clear();
					return;
				}
				// date('Y-m-d') - string arg, format and set input value
				else if (typeof argv === 'string') {
					_dtval = moment(argv, _input_format);
				}
				// date(moment) - moment arg, format and set input value
				else if (argv._isAMomentObject) {
					_dtval = argv;
				}
				// date(new Date()) - date object arg, set input value
				else if (typeof argv.getYear === 'function') {
					_dtval = moment();
				}

				if (init) {
					// fixes a weird iOS bug (unconfirmed for android):
					// iOS will not display the value the first time you set it,
					// you need to set it to a different value, then re-set it
					// back to the original value.
					// so, add 1 day/second to the date/time, then subtract it
					if (_input_format.indexOf('YYYY') >= 0) {
						_dt_modifier = 'day';
					}

					$el.val(_dtval.add(1, _dt_modifier).format(_input_format));
					$el.val(_dtval.subtract(1, _dt_modifier).format(_input_format));
				} else {
					$el.val(_dtval.format(_input_format));
				}

			},
			clear: function clear() {
				$el.val('');
			},
			minDate: function minDate(argv) {
				$el.attr('min', argv);
			},
			maxDate: function maxDate(argv) {
				$el.attr('max', argv);
			}
		});

		// event shim
		$el.on('change', function change() {
			// only trigger shim change event if not clearing the value
			if ($el.val().length) {
				$el.trigger({
					type: 'dp.change',
					date: moment($el.val()),
				});
			}
		});

		$el.data('DateTimePicker').date($el.data('value'), true);
	}

	// linked pickers hand their selected date to each other as a min/max
	// boundary. that date carries a time of day, which would push the same
	// day out of range for the picker being bounded.
	function _toDayBoundary(date, boundary, date_only)
	{
		if (!date || !date_only) {
			return date;
		}

		return moment(date)[boundary]('day');
	}

	function _initTempusDateTimePicker($el, opts) {
		const inputFormat  = opts.extraFormats[0];
		const outputFormat = opts.extraFormats[1];
		const options      = {
			allowInputToggle: false,
			useCurrent      : opts.useCurrent,
			restrictions    : {},
			localization    : {
				format             : inputFormat,
				dayViewHeaderFormat: 'LL',
			},
			display: {
				calendarWeeks: true,
				theme        : 'light',
				viewMode     : 'calendar',
				icons        : {
					type    : 'icons',
					date    : opts.icons.date,
					time    : opts.icons.time,
					up      : opts.icons.up,
					down    : opts.icons.down,
					previous: opts.icons.previous,
					next    : opts.icons.next,
					today   : opts.icons.today,
					clear   : opts.icons.clear,
					close   : opts.icons.close,
				},
				components: {
					calendar: true,
					date    : true,
					month   : true,
					year    : true,
					clock   : false,
					hours   : false,
					minutes : false,
					seconds : false,
				}
			},
		};

		// translate options to this new version
		if (opts.minDate) {
			options.restrictions.minDate = opts.minDate.toDate();
		}

		if (opts.maxDate) {
			options.restrictions.maxDate = opts.maxDate.toDate();
		}

		if (opts.stepping) {
			options.stepping = opts.stepping;
		}

		if (opts.viewMode) {
			if (opts.viewMode === 'decades') {
				opts.viewMode = 'years';
			}

			options.display.viewMode = opts.viewMode;
		}

		if (opts.viewDate) {
			options.viewDate = opts.viewDate.toDate();
		}

		// for time pickers, we need to set the view mode to clock
		if (opts.format.includes('hh') || options.display.viewMode === 'clock') {
			options.useCurrent                  = true;
			options.display.viewMode            = 'clock';
			options.display.calendarWeeks       = false;
			options.display.components.calendar = false;
			options.display.components.decades  = false;
			options.display.components.date     = false;
			options.display.components.year     = false;
			options.display.components.month    = false;
			options.display.components.clock    = true;
			options.display.components.hours    = true;
			options.display.components.minutes  = true;
			options.display.components.seconds  = false;
		}

		// if we have an initial value, set it to the correct picker format
		if ($el.val()) {
			options.useCurrent = false;

			$el.next().val($el.val());
			$el.val(moment($el.val(), outputFormat).format(inputFormat));
		}

		// use momentjs to parse dates/times
		tempusDominus.extend(tempusDominus.plugins.moment_parse, inputFormat);

		const picker = new tempusDominus.TempusDominus($el[0], options);

		picker.subscribe(tempusDominus.Namespace.events.change, function onChange(e) {
			// update the input value with the correct format
			if (e.date) {
				$el.val(moment(e.date).format(options.localization.format));
			}

			$el.trigger({
				type: 'dp.change',
				date: (e.date) ? moment(e.date) : null,
			});
		});

		const api = {
			tempus: picker,
			date  : function date(date) {
				if (typeof date !== 'string') {
					return;
				}

				const momentDate = moment(date);
				const dateObj    = momentDate.toDate();

				// update the display value
				$el.val(momentDate.format(options.localization.format));

				// update the date rendered in the picker
				const newDate = new tempusDominus.DateTime(dateObj);
				newDate.setMonth(dateObj.getMonth(), dateObj.getDate());
				newDate.setYear(dateObj.getFullYear());

				picker.viewDate = newDate;

				// set hidden input value
				$el.trigger({
					type: 'dp.change',
					date: momentDate,
				});
			},
			clear: function clear() {
				picker.clear();
			},
			maxDate: function maxDate(date) {
				picker.updateOptions({
					restrictions: {
						maxDate: date,
					},
				});
			},
			minDate: function minDate(date) {
				picker.updateOptions({
					restrictions: {
						minDate: date,
					},
				});
			},
			show: function show() {
				picker.show();
			},
		};

		return api;
	}

	Adzuki.DateTimePicker = dateTimePicker;
}(jQuery, window.Adzuki || {}));
